import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from '../../app.constants';
import { Toaster } from '../../classes/toaster.class';

@Component({
    selector: 'om-callback',
    templateUrl: './callback.component.html'
})
export class CallbackComponent implements OnInit {
    public title = 'Completing login...';
    public subtitle = 'Please wait while we redirect you.';
    private readonly router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);

    public ngOnInit(): void {
        const params = this.activatedRoute.snapshot.queryParamMap;
        const target = params.get('target') || AppConstants.HOME_PAGE;
        const error = params.get('error');
        const description = params.get('error_description');

        if (error) {
            this.title = 'Login failed';
            this.subtitle = description || error;
            Toaster.error(this.subtitle, this.title);
            return;
        }

        this.router.navigateByUrl(target).catch((err) => {
            Toaster.error(err?.message ?? 'Unable to redirect', 'Login');
        });
    }
}
